import React, { CSSProperties } from "react";
import { SimpleFieldProps, useSimpleFieldProps } from "./FormTools";
import { YupDefined, ErrorMessage } from "./Tools";

export function Textarea({
  maxLength = 150_000,
  textRows = 6,
  ...props
}: {
  field: SimpleFieldProps<string | null>;
  placeholder?: string;
  className?: string;
  style?: CSSProperties;
  type?: string;
  textboxIcon?: React.ReactNode;
  disabled?: boolean;
  textRows?: number;
  maxLength?: number;
}) {
  const field = useSimpleFieldProps(props.field);
  const getValueFromElement = (e: HTMLTextAreaElement) => {
    const result = e.value;
    return result === "" ? null : result;
  };
  return (
    <div className="control" style={{ flexGrow: 1, ...props.style }}>
      <textarea
        maxLength={maxLength}
        rows={textRows}
        className="textarea"
        placeholder={props.placeholder}
        disabled={props.disabled}
        name={field.name}
        value={field.value ?? ""}
        onFocus={e => field.onFocus(getValueFromElement(e.target))}
        onChange={e => field.onChange(getValueFromElement(e.target))}
        onBlur={e => field.onBlur(getValueFromElement(e.target))}
      />
      <ErrorMessage>{field.error}</ErrorMessage>
    </div>
  );
}

Textarea.getDefaultValidator = () => YupDefined.string().nullable();
